import { render } from "./dietaryguidanceDetail.vue?vue&type=template&id=de555d0a&scoped=true"
import script from "./dietaryguidanceDetail.vue?vue&type=script&lang=js"
export * from "./dietaryguidanceDetail.vue?vue&type=script&lang=js"

import "./dietaryguidanceDetail.vue?vue&type=style&index=0&id=de555d0a&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de555d0a"]])

export default __exports__